import { FieldGroupTypes } from '@/features/RfpForm/types/FieldGroupTypes'
import type {
  RfpFieldGroupEventName,
  RfpFieldGroupLocation,
} from '@/features/RfpForm/types/RfpFields'
import type { RfpHotel } from '@/AppRfp/types/GalaxyRfpFormItem'
import type { RfpFieldGroupAcceptTerms } from '@/features/RfpForm/types/RfpFields'

export const createLocationField = (hotels: RfpHotel[]): RfpFieldGroupLocation => {
  return {
    field_id: FieldGroupTypes.LOCATIONS,
    locations: [
      ...hotels.map((l) => {
        return {
          label: l.name,
          value: String(l.db2_rfp_location_id),
        }
      }),
    ],
  }
}

export const createAcceptTermsField = (terms: string): RfpFieldGroupAcceptTerms => {
  return {
    field_id: FieldGroupTypes.ACCEPT_TERMS,
    label: terms,
  }
}

export const createEventNameField = (): RfpFieldGroupEventName => {
  return {
    field_id: FieldGroupTypes.EVENT_NAME,
    is_mandatory: true,
  }
}
